'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function helmet(title, description, url) {
  var propTitle = title + ' | ' + _config2.default.app.title;
  url = url || _config2.default.domain;
  description = description || _config2.default.description;
  return _react2.default.createElement(_reactHelmet2.default, {
    title: title,
    meta: [{ property: 'og:url', content: url }, { property: 'twitter:title', content: propTitle }, { property: 'og:site_name', content: propTitle }, { property: 'og:title', content: propTitle }, { name: 'description', content: description }, { property: 'twitter:description', content: description }, { property: 'og:description', content: description }]
  });
}
exports.default = {
  helmet: helmet
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/container.js
// module id = 33
// module chunks = 0